import { useEffect, useState } from "react"
import { cancelSubscription } from "../../HTTP/subscription"
import { tailwindClassForColoredButton } from "../../Helper/utils"
import { deleteSubscription, fetchSubscriptionFromAllUsers, getUserById } from "../../HTTP/admin"
import TableElements from "./TableElements"
import ListElementsMobile from "./ListElementsMobile"
import SearchComponent from "./SearchComponent"

export default function AdminSubscription() {

    const localUser = JSON.parse(localStorage.getItem("user"))
    if (!localUser.super_admin && localUser.admin_access !== 3) {
        window.location.href = '/'
    }

    const url = new URL(window.location.href)

    const [subscriptionsWithUser, setSubscriptionsWithUser] = useState([])
    const [searchTerm, setSearchTerm] = useState("")
    const [launchSearch, setLaunchSearch] = useState(false)

    useEffect(() => {
        const funGetSubscription = async () => {
            let resSubscriptions;
            if (searchTerm.trim() === "") {
                resSubscriptions = await fetchSubscriptionFromAllUsers()
            } else {
                resSubscriptions = await fetchSubscriptionFromAllUsers(searchTerm)
            }
            setSubscriptionsWithUser(resSubscriptions)
        }
        funGetSubscription()
        setLaunchSearch(false)
    }, [launchSearch])

    const handleDeleteSub = async (id) => {
        if (window.confirm("Are you sure you want to delete this subscription ?")) {
            const res = await deleteSubscription(id)
            if (res) {
                alert("Subscription deleted")
                window.location.reload()
            } else {
                alert("Error deleting subscription")
            }
        }
    }

    const handleEditSub = (id) => {
        window.location.href = "/admin/subscription/edit/"+id
    }

    const handleAddSub = () => {
        window.location.href = "/admin/subscription/add"
    }

    const handleCancelSubscriptions = async (id) => {
        if (window.confirm("Are you sure you want to cancel this subscription ?")) {
            const res = await cancelSubscription(id)
            if (res) {
                alert("Subscription canceled")
                window.location.reload()
            } else {
                alert("Error canceling subscription")
            }
        }
    }

    const handleQuery = (e) => {
        e.preventDefault();
        url.searchParams.set('query', searchTerm);
        window.history.pushState({}, '', url);
        setLaunchSearch(true)
    }

    return (
    <>
        <div className="flex mt-8">
            <div className="flex-grow">
                <h1 className="text-center mt-4 text-2xl font-bold">
                    Gestion abonnement
                </h1>
                <div className="hidden xl:block ml-8 mr-8">
                <SearchComponent
                    searchTerm={searchTerm}
                    setSearchTerm={setSearchTerm}
                    handleQuery={handleQuery}
                    otherButton={{title:'Ajouter un abonnement', handle:handleAddSub}}
                />
                    <TableElements 
                        columns={[
                            {props:['firstname','lastname'],display:"Utilisateur",format:'fullName'}, 
                            {props:'start_date',display:"Date de début", format:'date'}, 
                            {props:'end_date',display:"Date de fin", format:'date'}, 
                            {props:'status',display:"Statut"},
                            {props:'tokens',display:"Tokens"},
                            {props:'',display:"Actions"}
                        ]}
                        data={subscriptionsWithUser}
                        buttons={[{display:'Modifier',action:handleEditSub, color:'blue', props:'id'}, {display:'Annuler l\'abonnement',action:handleCancelSubscriptions, color:'purple', props:'user_id', condition: (element) => element.status !== 'canceled'}, {display:'Supprimer',action:handleDeleteSub, color:'red', props:'id'}]}
                    />
                </div>
                <div className="xl:hidden w-full px-4 space-y-4">
                        <ListElementsMobile
                            columns={[
                                {props:['firstname','lastname'],display:"Utilisateur",format:'fullName'}, 
                                {props:'start_date',display:"Date de début", format:'date'}, 
                                {props:'end_date',display:"Date de fin", format:'date'},
                                {props:'status',display:"Statut"},
                                {props:'tokens',display:"Tokens"}, 
                                {props:'',display:"Actions"}
                            ]}
                            data={subscriptionsWithUser}
                            buttons={[{display:'Modifier',action:handleEditSub, color:'blue', props:'id'}, {display:'Annuler l\'abonnement',action:handleCancelSubscriptions, color:'purple', props:'user_id', condition:(element) => element.status !== 'canceled'}, {display:'Supprimer',action:handleDeleteSub, color:'red', props:'id'},]}
                        />
                </div>
            </div>
        </div>
    </>
    )
}